export default function(x) {
  return x<0 ? -1 : 1;
}


//////////////////
// WEBPACK FOOTER
// ./~/proj4/lib/common/sign.js
// module id = 28
// module chunks = 0 1